module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap myoreders-wrap personal-wrap"
  }, [(_vm.loadShow) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.loadShow,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.invoiceList.length == 0 && !_vm.loadShow) ? _c('empty', {
    attrs: {
      "imgpath": "/static/images/empty_invoice_3x.png",
      "btnurl": "/main/home",
      "emptytext": "您还没有发票信息",
      "btntext": "去逛一逛"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invoiceList.length != 0 && !_vm.loadShow),
      expression: "invoiceList.length!=0 && !loadShow"
    }],
    staticClass: "flex-column flex-item orders-list detail"
  }, [_vm._l((_vm.invoiceList), function(invoiceListShow) {
    return _c('div', {
      staticClass: "orders-list-item"
    }, [_c('div', {
      staticClass: "orders-list-item-title invoiceinfo-title"
    }, [_vm._v("\n        订单号：\n        "), _c('label', [_vm._v(_vm._s(invoiceListShow.orderId))]), _c('span', {
      staticClass: "fr"
    }, [_vm._v(_vm._s(invoiceListShow.orderTime))])]), _vm._v(" "), _c('mu-list', {
      staticStyle: {
        "border-bottom": "1px solid #e5e5e5"
      }
    }, _vm._l((invoiceListShow.goodsOrderMsgs), function(goodsShow, invoiceIndex) {
      return _c('myOrdersItem', {
        key: invoiceIndex,
        attrs: {
          "width": 150,
          "height": 150,
          "cartitem": goodsShow,
          "isRightTriggle": 'true'
        }
      })
    }), 1), _vm._v(" "), _c('div', {
      staticClass: "orders-list-item-state"
    }, [_c('p', [_vm._v("发票信息")]), _vm._v(" "), _c('div', {
      staticClass: "state"
    }, [_vm._v("\n          发票类型："), _c('span', {
      staticClass: "black"
    }, [_vm._v(_vm._s(invoiceListShow.invoiceData && invoiceListShow.invoiceData.invoiceTypeName || '无'))]), _vm._v(" "), _c('br'), _vm._v(" 发票内容：\n          "), _c('span', {
      staticClass: "black"
    }, [_vm._v(_vm._s(invoiceListShow.invoiceData && invoiceListShow.invoiceData.invoiceContentName || '无'))]), _vm._v(" "), _c('br'), _vm._v(" 发票抬头：\n          "), _c('span', {
      staticClass: "black"
    }, [_vm._v(_vm._s(invoiceListShow.invoiceData && invoiceListShow.invoiceData.invoiceHead || '无'))])])])], 1)
  }), _vm._v(" "), _c('mu-infinite-scroll', {
    attrs: {
      "scroller": _vm.scroller,
      "loading": _vm.loading,
      "loadingText": ""
    },
    on: {
      "load": _vm.loadMore
    }
  }), _vm._v(" "), ((_vm.lastPageNo == _vm.currentPage && !_vm.loadShow) || (_vm.total == 0 && !_vm.loadShow)) ? _c('p', {
    staticClass: "none-goods"
  }, [_vm._v("没有更多信息啦~")]) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20f76f65","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal/invoiceinfo.vue
// module id = 384
// module chunks = 68